<div
  class="app-root"
  [class.app-root--classic]="layoutTheme() === 'classic'"
  [attr.data-layout-theme]="layoutTheme()"
>
  <app-navbar />
  <router-outlet />
  <app-footer />
  <app-cookie-consent />
</div>
